import type { ButtonGlassProps } from './ButtonGlass.types';

/**
 * Button-chrome glass - WEB no-op. The browser renders the glass via the CVA's
 * `web:backdrop-blur-[6px]` on the button element itself (real CSS
 * `backdrop-filter`). The native sibling drops the DS `GlassBackground`
 * instead, since React Native has no `backdrop-filter`.
 */
export function ButtonGlass(_props: ButtonGlassProps): null {
  return null;
}
